import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ValidationMessageKeys } from 'src/Configuration/validation/translation-keys'
import * as z from 'zod'

interface ReturnType {
  dateRangeModalFormSchema: z.Schema
}

/**
 * Hook to validate "date range modal form" with zod
 */
const useValidateDateRangeModalForm = (): ReturnType => {
  const { t } = useCustomTranslation()
  const requiredMessage = t(ValidationMessageKeys.required)

  const dateRangeModalFormSchema = z.object({
    from: z.date({ message: requiredMessage }),
    to: z.date({ message: requiredMessage }),
  })

  return { dateRangeModalFormSchema }
}

export default useValidateDateRangeModalForm
